export const MessageStates = ['unread', 'check'] as const;
export type MessageState = (typeof MessageStates)[number];

export const MessageStateIcons = {
  unread: 'circle-small',
  check: 'check',
} as const;
